module.exports = __webpack_public_path__ + "static/img/3486_phase_function_Paper_PointsHejduk_Prediction.442f00a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3486_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ICZI
// module chunks = 0